/** @jsxImportSource @emotion/react */
"use client";
import type { Interpolation } from "@emotion/react";
import { forwardRef } from "react";

import { spacing } from "../../../../../../global/emotion";
import { Container } from "../../../../blocks/layout/Container/Container.emotion";
import type { StackProps } from "../../../../blocks/layout/Stack/Stack.emotion";
import { Stack } from "../../../../blocks/layout/Stack/Stack.emotion";
import { Text } from "../../../_core/Text/Text.emotion";

const stackStyle: Interpolation = {
  gap: spacing.none,
};

export type SectionsProps = StackProps & {
  title?: string;
};

export const Sections = forwardRef<any, SectionsProps>(
  ({ children, title, ...props }, ref) => (
    <Stack ref={ref} css={stackStyle} {...props}>
      {title && (
        <Container paddingX paddingY>
          <Text as="h1" overflow="ellipsis" size="s" type="display">
            {title}
          </Text>
        </Container>
      )}
      {children}
    </Stack>
  ),
);

Sections.displayName = "Sections";
